function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "html_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "html_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#html_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "html-5-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "html-5-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#html_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.24985 43.1704C3.29857 43.7938 3.72054 44.3254 4.31666 44.5144L21.3924 49.9283C21.6944 50.024 22.0186 50.024 22.3206 49.9283L39.3964 44.5144C39.9925 44.3254 40.4145 43.7938 40.4632 43.1704L43.7083 1.6552C43.7781 0.762645 43.0727 0 42.1775 0L1.53569 0C0.640482 0 -0.0649246 0.762645 0.0047523 1.6552L3.24985 43.1704ZM14.2375 14.536L14.8758 20.4217L34.9264 20.4217L33.6148 37.2009L21.8566 40.9288L10.0983 37.2009L9.41309 28.4347L15.5847 28.4347L15.5847 32.7347L22.0215 34.4622L28.4198 32.7347L28.9162 25.8818L9.2135 25.8818L7.90542 9.14656L35.8076 9.14656L35.3864 14.536L14.2375 14.536Z",
  transform: "translate(3.1435547 0)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgHtml5 = function SvgHtml5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHtml5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/html-5.947175dd.svg";
export { ForwardRef as ReactComponent };